import hermes from "hermes"
import { q } from "../../helper/q"
import { styler, tween, easing } from "popmotion"
// import { interpolate } from "polymorph-js"
import { interpolate } from "flubber"
import { del } from "./del"
let state = { open: false, preload: false }

export const show = () => {
  window.addEventListener("load", () => {
    loadCart()
  })
  hermes.on("updateBasket", data => {
    updateIcon(data)
    if (data.action === "add") loadCart()
  })

  initModal()
}
let modalTimeout

const initModal = () => {
  const buttons = Array.from(document.querySelectorAll("basket-element"))
  const modal = document.querySelector(".modalCart")

  buttons.map(button => {
    button.addEventListener("click", e => {
      e.preventDefault()
      if (state.open) {
        modal.classList.remove("modalCartShow")
        clearTimeout(modalTimeout)
        modalTimeout = setTimeout(() => {
          modal.classList.remove("modalCartTransition")
        }, 750)
        document.body.style.overflow = "auto"
        state.open = false
        iconSet()
      } else {
        document.body.style.overflow = "hidden"
        state.open = true
        iconSet()
        if (!state.preload) {
          loadCart(state).then(() => {
            modal.classList.add("modalCartTransition")
            modal.classList.add("modalCartShow")
          })
        } else {
          modal.classList.add("modalCartTransition")
          modal.classList.add("modalCartShow")
        }
      }
    })
  })
}

const iconSet = () => {
  const basket = q("basket-element")
  const span = q("span", basket)

  const cart = q("#cart").getAttribute("d")
  const close = q("#close").getAttribute("d")

  const morph = interpolate(cart, close, { maxSegmentLength: 2 })
  const morphBack = interpolate(close, cart, { maxSegmentLength: 2 })
  const shape = styler(document.querySelector("#target"))

  if (state.open) {
    span.hidden = true
    tween({
      duration: 700,
      ease: easing.easeInOut
    })
      .pipe(morph)
      .start(shape.set("d"))
  } else {
    span.hidden = false
    tween({
      duration: 700,
      ease: easing.easeInOut
    })
      .pipe(morphBack)
      .start(shape.set("d"))
  }
}

export const loadCart = () => {
  const modal = document.querySelector(".modalCart")
  return fetchCart().then(res => {
    modal.innerHTML = res
    closeModal(modal)
    del()
    state.preload = true
  })
}

const closeModal = modal => {
  const closeElement = document.querySelector(".basketButtonClose")
  if (closeElement) {
    closeElement.addEventListener("click", () => {
      modal.classList.remove("modalCartShow")
      clearTimeout(modalTimeout)
      modalTimeout = setTimeout(() => {
        modal.classList.remove("modalCartTransition")
      }, 750)
      document.body.style.overflow = "auto"
      state.open = false
    })
  }
}

const fetchCart = () => {
  const options = {
    method: "GET",
    credentials: "include"
  }
  return fetch("/cart/?AJAX=Y", options).then(res => res.text())
}

export const updateIcon = data => {
  const sideCartElement = document.querySelector(".js-top-cart")
  const basketElement = document.querySelector(".buttonBasket")
  const basketElementQuantity = document.querySelector(".buttonBasket span")
  if (data.action === "add") {
    setTimeout(() => {
      if (sideCartElement) {
        clearTimeout(timeout)
        basketElementQuantity.classList.add("basketAnimate")
        const timeout = setTimeout(() => {
          basketElementQuantity.classList.remove("basketAnimate")
        }, 1000)
      }
    }, 500)
  }
  basketElement.value = data.count
}
